<script lang="ts" setup>
  import { cn } from "@/lib/utils"
  import type { LabelProps } from "reka-ui"
  import type { HTMLAttributes } from "vue"
  import { Label } from "@/components/ui/inputs/label"

  import { useFormField } from "./useFormField"

  const props = defineProps<LabelProps & { class?: HTMLAttributes["class"] }>()

  const { formItemId } = useFormField()
</script>

<template>
  <!-- Web:S6853 suppressed in sonar-project.properties: Label is our own component (reka-ui Label primitive under the
  hood), not a native <label>; formItemId and the slot content are always
  non-empty at runtime (see useFormField), so the for/text association is
  real — the analyzer can't see that across the composable/slot boundary. -->
  <Label
    :class="
      cn(
        'peer-disabled:cursor-not-allowed peer-disabled:text-secondary-400',
        props.class,
      )
    "
    :for="formItemId"
  >
    <slot />
  </Label>
</template>
